import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import React, { useEffect, useState } from "react";
import Modal from "./common/Modal";
import * as XLSX from "xlsx";
import { faDownload } from "@fortawesome/pro-light-svg-icons";
import AwesomeIcon from "./AwesomeIcon";
function CSVModal(_ref) {
  var selectedFile = _ref.selectedFile,
    setSelectedFile = _ref.setSelectedFile,
    type = _ref.type;
  var _useState = useState([]),
    data = _useState[0],
    setData = _useState[1];
  useEffect(function () {
    if (!!selectedFile) {
      if (type === "upload") {
        var reader = new FileReader();
        reader.onload = function (e) {
          var _e$target;
          var arrayBuffer = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.result;
          if (arrayBuffer) {
            var workbook = XLSX.read(arrayBuffer, {
              type: "array"
            });
            var sheetName = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[sheetName];
            var jsonData = XLSX.utils.sheet_to_json(worksheet, {
              header: 1
            });
            setData(jsonData);
          }
        };
        reader.onerror = function (error) {
          console.error("Error reading file:", error);
        };
        reader.readAsArrayBuffer(selectedFile);
      } else {
        fetch(selectedFile).then(function (res) {
          return res.arrayBuffer();
        }).then(function (data) {
          var workbook = XLSX.read(data, {
            type: "array"
          });
          var sheetName = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[sheetName];
          var jsonData = XLSX.utils.sheet_to_json(worksheet, {
            header: 1
          });
          setData(jsonData);
        })["catch"](function (error) {
          return console.error("Error reading Excel file:", error);
        });
      }
    }
  }, [selectedFile, type]);
  var handleDownload = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var response, blob, url, a, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return fetch(selectedFile);
          case 1:
            response = _context.v;
            _context.n = 2;
            return response.blob();
          case 2:
            blob = _context.v;
            url = URL.createObjectURL(blob);
            a = document.createElement("a");
            a.href = url;
            a.download = "data.csv";
            a.click();
            URL.revokeObjectURL(url);
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error("Error downloading file:", _t);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 3]]);
    }));
    return function handleDownload() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Modal, {
    title: /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between space-x-4"
    }, /*#__PURE__*/React.createElement("p", null, "CSV FILE PREVIEW"), type !== "upload" && /*#__PURE__*/React.createElement("button", {
      onClick: handleDownload,
      title: "Download"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faDownload,
      className: "cursor-pointer hover:text-teal-100 text-teal-200 ml-2"
    }))),
    onClose: function onClose() {
      setSelectedFile(null);
    },
    show: !!selectedFile,
    closeOnClickAway: true,
    bgOpacity: true,
    titleClassName: "!text-base",
    className: "flex flex-col w-full text-left sm:w-7/12 !p-0 !bg-gray-100 dark:!bg-gray-800 lg:w-6/12 xl:w-2/3 overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-2 flex justify-center max-h-[60vh]"
  }, data.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "bg-white w-full rounded-lg shadow-lg p-6 overflow-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overflow-auto"
  }, /*#__PURE__*/React.createElement("table", {
    className: "min-w-full text-md border"
  }, /*#__PURE__*/React.createElement("tbody", null, data === null || data === void 0 ? void 0 : data.map(function (row, rowIndex) {
    return /*#__PURE__*/React.createElement("tr", {
      key: rowIndex,
      className: "border-b"
    }, row === null || row === void 0 ? void 0 : row.map(function (cell, cellIndex) {
      return /*#__PURE__*/React.createElement("td", {
        key: cellIndex,
        className: "border border-gray-400 px-2 py-2 text-gray-800 whitespace-break-spaces"
      }, cell);
    }));
  })))))));
}
export default CSVModal;